import React, { Component } from "react";
import styles from "./Layouts.local.scss";
import classnames from "classnames";
import { ComponentFactory } from "../Components/ComponentFactory";
import {
  hasExplanation,
  checkAndGetExplanations,
  checkForComments
} from "Utils";

//  ________________________________
// |          |         |           |
// |__________|_________|___________|
// |                                |
// |                                |
// |                                |
// |________________________________|

class Layout10 extends Component {
  render() {
    const {
      slideId,
      selectedComponent,
      layoutData: { components },
      componentsBackground,
      isResponsive,
      isPresentation,
      comments,
      explanations,
      isPreparePresentation
    } = this.props;

    const customBackground = {
      background: componentsBackground
    };

    return (
      <div className={`row ${styles.layout}`}>
        <div
          className={`large-12 medium-12 small-12 ${styles.component_block}`}
        >
          <div className={`${styles.flex_container}`}>
            <div
              className={classnames(
                isResponsive ? "large-4 medium-12 small-12" : "small-4",
                styles.component_block,
                styles.flex_container,
                styles.align_container,
                isPresentation &&
                  (selectedComponent === components[1].componentId
                    ? styles.gradient_border
                    : "")
              )}
            >
              <div
                className={classnames(
                  styles.component_container,
                  styles.container_m_height
                )}
                style={customBackground}
              >
                {/********** Component n°1 ********/}
                <ComponentFactory
                  component={components[1]}
                  layoutProps={{
                    customBackground: customBackground
                  }}
                  isPresentation={isPresentation}
                  isPreparePresentation={isPreparePresentation}
                  hasComments={
                    isPresentation &&
                    checkForComments(components[1], comments, slideId)
                  }
                  indicatorsExplanation={
                    isPresentation
                      ? checkAndGetExplanations(components[1], explanations)
                      : null
                  }
                  hasExplanation={
                    isPresentation && hasExplanation(components[1])
                  }
                />
              </div>
            </div>
            <div
              className={classnames(
                isResponsive ? "large-4 medium-12 small-12" : "small-4",
                styles.component_block,
                styles.flex_container,
                styles.align_container,
                isPresentation &&
                  (selectedComponent === components[2].componentId
                    ? styles.gradient_border
                    : "")
              )}
            >
              <div
                className={classnames(
                  styles.component_container,
                  styles.container_m_height
                )}
                style={customBackground}
              >
                {/********** Component n°2 ********/}
                <ComponentFactory
                  component={components[2]}
                  layoutProps={{
                    customBackground: customBackground
                  }}
                  isPresentation={isPresentation}
                  isPreparePresentation={isPreparePresentation}
                  hasComments={
                    isPresentation &&
                    checkForComments(components[2], comments, slideId)
                  }
                  indicatorsExplanation={
                    isPresentation
                      ? checkAndGetExplanations(components[2], explanations)
                      : null
                  }
                  hasExplanation={
                    isPresentation && hasExplanation(components[2])
                  }
                />
              </div>
            </div>
            <div
              className={classnames(
                isResponsive ? "large-4 medium-12 small-12" : "small-4",
                styles.component_block,
                styles.flex_container,
                styles.align_container,
                isPresentation &&
                  (selectedComponent === components[3].componentId
                    ? styles.gradient_border
                    : "")
              )}
            >
              <div
                className={classnames(
                  styles.component_container,
                  styles.container_m_height
                )}
                style={customBackground}
              >
                {/********** Component n°3 ********/}
                <ComponentFactory
                  component={components[3]}
                  layoutProps={{
                    customBackground: customBackground
                  }}
                  isPresentation={isPresentation}
                  isPreparePresentation={isPreparePresentation}
                  hasComments={
                    isPresentation &&
                    checkForComments(components[3], comments, slideId)
                  }
                  indicatorsExplanation={
                    isPresentation
                      ? checkAndGetExplanations(components[3], explanations)
                      : null
                  }
                  hasExplanation={
                    isPresentation && hasExplanation(components[3])
                  }
                />
              </div>
            </div>
            <div
              className={classnames(
                isResponsive ? "large-12 medium-12 small-12" : "small-12",
                styles.component_block,
                styles.flex_container,
                styles.align_container,
                isPresentation &&
                  (selectedComponent === components[4].componentId
                    ? styles.gradient_border
                    : "")
              )}
            >
              <div
                className={classnames(
                  styles.component_container,
                  styles.container_l_height
                )}
                style={customBackground}
              >
                {/********** Component n°2 ********/}
                <ComponentFactory
                  component={components[4]}
                  layoutProps={{
                    customBackground: customBackground,
                    scaleComponent: true,
                    containerHeight: 300
                  }}
                  isPreparePresentation={isPreparePresentation}
                  isPresentation={isPresentation}
                  hasComments={
                    isPresentation &&
                    checkForComments(components[4], comments, slideId)
                  }
                  indicatorsExplanation={
                    isPresentation
                      ? checkAndGetExplanations(components[4], explanations)
                      : null
                  }
                  hasExplanation={
                    isPresentation && hasExplanation(components[4])
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Layout10;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Layouts/Layout10.js